import {
  FieldFunctionOptions,
  FieldMergeFunction,
  InMemoryCacheConfig,
} from '@apollo/client';
import {
  QuerySearchLocationByPortArgs,
  SearchLocationResult,
} from '../../../generated/gql';

export const locationPaginationMerger = (
  oldValue: SearchLocationResult | undefined,
  newValue: SearchLocationResult,
  options: FieldFunctionOptions<QuerySearchLocationByPortArgs>,
) => {
  if (!options.args?.lastPageToken) return newValue;

  let locations = [...(oldValue?.locations || [])];
  if (newValue.lastPageToken?.id !== oldValue?.lastPageToken?.id) {
    locations = locations.concat([...(newValue.locations || [])]);
  }

  return { ...newValue, locations };
};

export const refLocationCacheConfig: InMemoryCacheConfig = {
  addTypename: true,
  typePolicies: {
    Query: {
      fields: {
        searchLocationByPort: {
          keyArgs: ['port', 'searchString'],
          merge: locationPaginationMerger as FieldMergeFunction<any, any>,
        },
      },
    },
    LocationPageToken: {
      keyFields: false,
    },
  },
};
